import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ApiConfiguration,
  documentsControllerFindAllActive,
  documentsControllerFindByIdentifier,
  DocumentsControllerFindByIdentifier$Params,
} from '@klubovna/api-client';
import { DocumentItem } from '@klubovna/shared-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DocumentsApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getDocuments(): Observable<DocumentItem[]> {
    return documentsControllerFindAllActive(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body as unknown as DocumentItem[]));
  }

  getDocumentByIdentifier(identifier: string): Observable<DocumentItem> {
    const params: DocumentsControllerFindByIdentifier$Params = { identifier };
    return documentsControllerFindByIdentifier(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as unknown as DocumentItem));
  }
}
